import { gql } from "@apollo/client";

export const setTagsData = gql`
    mutation setTags($lensId: ID!, $tagsList: [String!]!) {
        setTags(input: { lensId: $lensId, tagsList: $tagsList }) {
            lens {
                id
                tagsList
            }
        }
    }
`;
